import React from 'react';

import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { List, ListItemButton, ListItemText } from '@mui/material';

import type { OpportunityRoomAsset } from '~/hooks/apis/offers/useGetOffer';

interface Props {
  roomAssets: Array<OpportunityRoomAsset>;
  selectedSfid?: string;
  onSelect: (sfid: string) => void;
}

export default function RoomAssetList({ roomAssets, selectedSfid, onSelect }: Props) {
  return (
    <List component="nav" aria-label="Room assets" dense disablePadding>
      {roomAssets.map((roomAsset) => (
        <ListItemButton
          key={roomAsset.sfid}
          selected={roomAsset.sfid === selectedSfid}
          onClick={() => roomAsset.sfid && onSelect(roomAsset.sfid)}
        >
          <ListItemText primary={roomAsset.name || roomAsset.sfid} />
          <ChevronRightIcon fontSize="small" color="action" />
        </ListItemButton>
      ))}
    </List>
  );
}
